import { AbacoVuexModule, State } from "@abaco/web-common/src/app";

export default class DemoColdirettiPopUpVuexModule extends AbacoVuexModule {
    @State() showDemoModal!: boolean;
    @State({default: false}) hasAlreadySubmittedSubscription!: boolean;
    @State({default: false}) hasBeenAlreadyOpenedOneTime!: boolean;
}